export default __webpack_public_path__ + "static/media/news-right-big-homepage.ba4b55af.png";